exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__toggle-root___1Jj9M{width:100%}", ""]);

// exports
exports.locals = {
	"toggle-root": "styles__toggle-root___1Jj9M"
};